import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useInView } from 'react-intersection-observer';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    st0: { fill: 'none', stroke: '#FDB714', strokeWidth: '2' },
    st1: { fill: '#0a6eb4' },
    st2: { fontWeight: 'bold' },
    st3: { fontSize: '9.5832px' },
    st4: { fontSize: '9.68px' },
    st5: { fill: '#FDB714' },
    st6: { fontSize: '11.979px' },

    draw: {
      animation: `$draw 1.5s linear forwards`,
      transformOrigin: 'center 82%',
      transform: 'scaleY(0)',
    },
    '@keyframes draw': {
      ...animationFunc(),
    },
  }),
);

function animationFunc() {
  return {
    to: {
      transform: 'scaleY(1)',
    },
  };
}

const LargestContributions = () => {
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0,
  });

  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 490.89 170.28"       ref={ref}>
      <style type="text/css"></style>
      <g>
        <line className={classes.st0} x1="12.15" y1="145.73" x2="479.74" y2="145.73" />
        <text
          transform="matrix(1 0 0 1 37.5532 162.6554)"
          className={clsx(classes.st1, classes.st2, classes.st3)}
        >
          TURKEY
        </text>
        <text
          transform="matrix(1 0 0 1 134.1118 162.6554)"
          className={clsx(classes.st1, classes.st2, classes.st4)}
        >
          YEMEN
        </text>
        <text
          transform="matrix(1 0 0 1 422.9146 162.6554)"
          className={clsx(classes.st1, classes.st2, classes.st4)}
        >
          CHAD
        </text>
        <text
          transform="matrix(1 0 0 1 222.771 162.6554)"
          className={clsx(classes.st1, classes.st2, classes.st4)}
        >
          LEBANON
        </text>
        <g>
          <path
            className={clsx(classes.st5, inView && classes.draw)}
            d="M12.02,140.14h86.74V17.39c0-4.7-3.81-8.5-8.5-8.5H20.53c-4.7,0-8.5,3.81-8.5,8.5L12.02,140.14L12.02,140.14z
			"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_1_"
                d="M20.52,8.89c-4.7,0-8.5,3.81-8.5,8.5v122.75h86.74V17.39c0-4.7-3.81-8.5-8.5-8.5H20.52z"
              />
            </defs>
          </g>
        </g>
        <text
          transform="matrix(1 0 0 1 33.022 136.3253)"
          className={clsx(classes.st1, classes.st2, classes.st6)}
        >
          € 350 M
        </text>
        <g>
          <path
            className={clsx(classes.st5, inView && classes.draw)}
            d="M202.51,140.14h86.74v-43.9c0-4.7-3.81-8.5-8.5-8.5h-69.73c-4.7,0-8.5,3.81-8.5,8.5L202.51,140.14
			L202.51,140.14z"
          />
        </g>
        <text
          transform="matrix(1 0 0 1 226.9287 136.3253)"
          className={clsx(classes.st1, classes.st2, classes.st6)}
        >
          € 48 M
        </text>
        <text
          transform="matrix(1 0 0 1 324.3281 162.6554)"
          className={clsx(classes.st1, classes.st2, classes.st4)}
        >
          SUDAN
        </text>
        <g>
          <path
            className={clsx(classes.st5, inView && classes.draw)}
            d="M479.74,140.14v-8.2c0-4.53-3.67-8.2-8.2-8.2H401.2c-4.53,0-8.2,3.67-8.2,8.2v8.2H479.74z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_3_"
                d="M401.2,123.73c-4.53,0-8.2,3.67-8.2,8.2v8.2h86.74v-8.2c0-4.53-3.67-8.2-8.2-8.2H401.2z"
              />
            </defs>
          </g>
        </g>
        <text
          transform="matrix(1 0 0 1 417.417 136.3253)"
          className={clsx(classes.st1, classes.st2, classes.st6)}
        >
          € 16 M
        </text>
        <g>
          <path
            className={clsx(classes.st5, inView && classes.draw)}
            d="M107.27,140.14h86.74V83.02c0-4.7-3.81-8.5-8.5-8.5h-69.73c-4.7,0-8.5,3.81-8.5,8.5L107.27,140.14
			L107.27,140.14z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_5_"
                d="M115.77,74.51c-4.7,0-8.5,3.81-8.5,8.5v57.12h86.74V83.01c0-4.7-3.81-8.5-8.5-8.5H115.77z"
              />
            </defs>
          </g>
        </g>
        <text
          transform="matrix(1 0 0 1 131.6851 136.3253)"
          className={clsx(classes.st1, classes.st2, classes.st6)}
        >
          € 52 M
        </text>
        <g>
          <path
            className={clsx(classes.st5, inView && classes.draw)}
            d="M297.75,140.14h86.74v-24.31c0-4.7-3.81-8.5-8.5-8.5h-69.73c-4.7,0-8.5,3.81-8.5,8.5L297.75,140.14
			L297.75,140.14z"
          />
        </g>
        <g>
          <g>
            <defs>
              <path
                id="SVGID_7_"
                d="M306.26,107.33c-4.7,0-8.5,3.81-8.5,8.5v24.31h86.74v-24.31c0-4.7-3.81-8.5-8.51-8.5H306.26z"
              />
            </defs>
          </g>
        </g>
        <text
          transform="matrix(1 0 0 1 322.1729 136.3253)"
          className={clsx(classes.st1, classes.st2, classes.st6)}
        >
          € 27 M
        </text>
      </g>
    </svg>
  );
};

export default LargestContributions;
